/* eslint-disable max-len */
import classnames from 'classnames';
import React from 'react';
import { Carousel } from 'react-bootstrap';
import { Control, FieldErrors, UseFormRegister } from 'react-hook-form';
import TextArea from 'v2/form/TextArea/TextArea';
import styles from './proposalMainResponse.module.scss';
import CheckSellerResponse from '../../CheckResponse/CheckSellerResponse';
import { ProviderProposalTokenResponseFields } from 'v2/pages/ProposalResponseToken/ProposalResponse';
import { ProviderProposalResponseFields } from 'v2/models';

interface ProposalMainResponseProps {
  register: UseFormRegister<ProviderProposalResponseFields>;
  errors: FieldErrors<ProviderProposalResponseFields>;
  isCheckSellerResponseEnabled: boolean;
  control: Control<ProviderProposalResponseFields>;
  searchDescription: string;
}

const EXAMPLES = [
  'Our dataset has visibility into 40% of consumer loans in the United States. By filtering this dataset specifically to student loans we are able to see a monthly snapshot of how many student loans are late on their payment.',
  'Our satellite data tracks the locations of cargo ships globally, in real time. By aggregating the tonage of these cargo ships by day and by country we are able to see high frequency changes in import and export activity across the globe.',
  'Our software helps auto collission apraisers evaluate a damaged automobile and estimate the repair costs. Our software stores photos of the automobiles. We have over 550k images of damaged vehicles which can be used to train your machine learning models.',
  'Our ad platform sees over 4B impressions a day, including the site that generated the impression. Using this data we can deliver mobile advertising IDs for customers visiting travel sites in anticipation of taking a trip. Our data is updated hourly and can be delivered directly into your advertising campaigns.',
];

const ProposalMainResponse = ({
  register,
  errors,
  isCheckSellerResponseEnabled,
  control,
  searchDescription,
}: ProposalMainResponseProps) => {
  const errorMsg = errors?.response?.message;
  const convertedControl = control as Control<
    ProviderProposalResponseFields | ProviderProposalTokenResponseFields
  >;

  return (
    <>
      <div className="px-3 pt-1">
        <Carousel className={styles.carousel} indicators={true} interval={null}>
          {EXAMPLES.map((example, index) => (
            <Carousel.Item key={index}>
              <Carousel.Caption>
                <h5
                  className={classnames(
                    'text-primary-dark font-weight-bold text-center',
                    styles.exampleNumber
                  )}
                >
                  Example {index + 1}
                </h5>
                <p
                  className={classnames(
                    'text-primary-dark text-center font-italic font-14 m-0',
                    styles.exampleText
                  )}
                >
                  {example}
                </p>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>

        <TextArea
          className={classnames(
            styles.textArea,
            errorMsg ? 'provider-response-error' : ''
          )}
          register={register('response', { required: true })}
          rows={5}
          autoComplete="off"
          required={true}
          placeholder="Type your answer here..."
          data-cy="proposal-modal-data-provider-response-text-input"
        />
        {errorMsg ? <p className="text-danger">{errorMsg}</p> : null}
      </div>
      {isCheckSellerResponseEnabled && (
        <div className="px-3">
          <CheckSellerResponse
            control={convertedControl}
            errors={errors}
            searchDescription={searchDescription}
          />
        </div>
      )}
    </>
  );
};

export default ProposalMainResponse;
